import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from "vue-i18n-composable";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceptObnlMembershipSection',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {





const { t: $t } = useI18n();

return { __sfc: true,$t }
}

})